import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../actions/search';
import {withRouter} from 'react-router';
import Loader from '../../components/Loader';
import { setSearchScope } from '../../helpers';
class AddressesOverview extends Component {

    constructor(props,context) {
        super(props,context);

        this.columns = [{
              Header: 'Klant',
              accessor: 'client_name',
              Cell: props =>  <span><a href={'/#/clients/update/'+props.row._original.client_id} style={{display : 'inline'}} className="nav-link">{props.value}</a></span>
        },{
              Header: 'Adres naam',
              accessor: 'vve_address_name',
        },{
              Header: 'Straat',
              accessor: 'street',
        },{
              Header: 'Postcode',
              accessor: 'zipcode',
        },{
              Header: 'Stad',
              accessor: 'city',
        }]

        this.additionalColumns = [{
            Header: 'Actief',
            accessor: 'is_active',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: '#',
            accessor: 'dp_address_id',
            Cell: props => <span className={props.row._original.user_id ? props.row._original.user_name ? '' : 'disabled' : 'disabled'}><i className="fa fa-plus"></i> <a href={'/#/files/add/address/'+props.value}>Bestand toevoegen</a></span>
        },{
            Header: '#',
            accessor: 'dp_address_id',
            Cell: props => <span className={props.row._original.files ? props.row._original.files.length ? '' : 'disabled' : 'disabled'} ><i className="fa fa-eye"></i> <a href={'/#/addresses/view/'+props.value}>Bestanden bekijken</a></span>
        }
        ]
    }

    componentWillMount() {
        setSearchScope('addresses');
        this.props.updateSearchData(this.props.clientData.allAddresses)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const filterValues = {
            isActive : {
                name: 'Is Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '1'
            },
            isNotActive : {
                name: 'Niet Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '0'
            }
        }
        return (
            this.props.clientData.data ?
            <Card>
                <CardHeader><Search filters={filterValues} data={this.props.clientData.allAddresses} keys_to_filter={['client_name','vve_address_name','street', 'zipcode', 'city', 'files.metaDataValues']}/></CardHeader>
                <CardBody>
                    <CardTitle><i className="fa fa-align-justify"></i> Adressen overzicht</CardTitle>
                    <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.clientData.allAddresses} columns={this.columns} />
                </CardBody>
            </Card>
             : <Loader />
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddressesOverview))



// WEBPACK FOOTER //
// ./src/views/Addresses/index.js